import { StrapiArticleFlag } from '../../interfaces/strapi-rules.modal';

export enum IconWeight {
  SOLID = 'solid',
  REGULAR = 'regular',
  LIGHT = 'light',
  DUOTONE = 'duotone',
  BRANDS = 'brands',
}

export interface ConfirmationInput {
  icon?: string | string[];
  iconColor?: string;
  iconWeight?: IconWeight;
  iconSrc?: string;
  iconSrcWidth?: string;
  iconSrcHeight?: string;
  title?: string;
  subtitle?: string;
  info?: string;
  actions?: Action[];
  extraInfo?: string;
  secondaryModalLabel?: string;
  secondaryModalCopy?: string;
  secondaryModalTitle?: string;
  tertiaryModalLabel?: string;
  tertiaryModalCopy?: string;
  tertiaryModalTitle?: string;
  chatbotId?: string;
  tiles?: any[];
  accordionObj?: AccordionObj;
  flags?: StrapiArticleFlag[];
  supportOptions?: any;
  tilesContainerCopy?: string;
  tilesContainerHeading?: string;
}

export interface AccordionObj {
  accordions?: any[];
  accordionContainerHeading?: string;
}

export interface Action {
  uid?: string;
  url?: string;
  label?: string;
  type?: number | string;
  buttonLevel?: number | string;
  contentType?: string;
}
